/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ConstantService extends services.DataService<Wars.Domain.Model.ConstantValue> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getAllConstantsForProcessConfiguration(id: string): ng.IPromise<Wars.Domain.Model.ConstantValue[]> {
            const query = this.breezeModule.EntityQuery
                .from("ConstantValues")
                .where("processConfiguration_id", "==", id);

            return this.executeQuery(query); 
        }

        public createConstant(): Wars.Domain.Model.ConstantValue {
            return this.createNewEntity<Wars.Domain.Model.ConstantValue>("ConstantValue");
        }

        public getConstant(id: string): ng.IPromise<Wars.Domain.Model.ConstantValue> {
            const query = this.breezeModule.EntityQuery
                .from("ConstantValues")
                .where("id", "==", id);

            return this.fetch(query); 
            //TODO: this call I am guessing due to caching would every once in a while return a null constant here when one existed in the DB with the specified ID. 
            //TODO: when we have more time spend a minute to figure out why
            //return this.fetchById(id, "ConstantValue");
        }
    }
}

warsApp.registerService('ConstantService', ['breeze', '$q']);